function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.7163 0.0141296H6.2839C2.8189 0.0141296 0 2.83389 0 6.29975V19.7006C0 23.1665 2.8189 25.9861 6.2839 25.9861H29.7164C33.1813 25.9861 36.0002 23.1665 36.0002 19.7006V6.29975C36 2.83389 33.1811 0.0141296 29.7163 0.0141296ZM33.4245 19.7004C33.4245 21.7462 31.761 23.4104 29.7163 23.4104H6.2839C4.239 23.4104 2.57544 21.7462 2.57544 19.7004V6.29957C2.57544 4.25382 4.239 2.58957 6.2839 2.58957H29.7164C31.7612 2.58957 33.4247 4.25382 33.4247 6.29957V19.7004H33.4245Z",
  fill: "#4563CB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9132 11.9246L15.3676 5.63199C14.9722 5.37118 14.4655 5.34886 14.0483 5.57327C13.6312 5.79784 13.3711 6.23344 13.3711 6.70715V19.294C13.3711 19.7677 13.6312 20.2031 14.0483 20.4279C14.2394 20.5309 14.4493 20.5817 14.6586 20.5817C14.9062 20.5817 15.1533 20.5105 15.3676 20.369L24.9132 14.0748C25.2746 13.8365 25.4921 13.4326 25.4921 12.9996C25.4921 12.5668 25.2746 12.163 24.9132 11.9246ZM15.9465 16.9024V9.09835L21.8651 12.9998L15.9465 16.9024Z",
  fill: "#4563CB"
});

var SvgIcoYoutube = function SvgIcoYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_youtube.2252b873.svg";
export { ForwardRef as ReactComponent };